import BaseApi from './BaseApi';
import OwnershipContactCategoryForm from 'src/models/OwnershipContactCategoryForm';

export interface IOwnershipContactCategories {
    getForm(clientNumber: number, projectNumber: number, jwt: string): Promise<object>;
    get(clientNumber: number, projectNumber: number, jwt: string): Promise<object>;
    getAttachedOwners(clientNumber: number, projectNumber: number, jwt: string): Promise<object>;
    save(ownershipContactCategoryForm: OwnershipContactCategoryForm, clientNumber: number, projectNumber: number, jwt: string): Promise<object>;
}

export default class OwnershipContactCategories extends BaseApi implements IOwnershipContactCategories {
    constructor(baseUrl: string) {
        super(baseUrl);
    }
    getForm = (clientNumber: number, projectNumber: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/ownershipcontactcategories/form`, jwt);
    };
    get = (clientNumber: number, projectNumber: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/ownershipcontactcategories`, jwt);
    };
    getAttachedOwners = (clientNumber: number, projectNumber: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/ownershipcontactcategories/owners`, jwt);
    };
    save = (ownershipContactCategoryForm: OwnershipContactCategoryForm, clientNumber: number, projectNumber: number, jwt: string) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/ownershipcontactcategories`,
            ownershipContactCategoryForm,
            jwt
        );
    };
}



// WEBPACK FOOTER //
// ./src/api/OwnershipContactCategories.ts